/* eslint-disable import/prefer-default-export */
import { isMessage, message, localizeSystemText } from './messages';

const billingErrors = {
  BILLING_REVISION_CONFLICT: 'conflict',
  BILLING_REQUEST_ID_CONFLICT: 'conflict',
  BILLING_ENTRY_EXISTS: 'conflict',
  BILLING_ASSIGNMENT_PENDING: 'pending',
  BILLING_INSUFFICIENT_OVERPAYMENT: 'insufficient',
  BILLING_TRANSFER_ALREADY_REVERSED: 'reversed',
  INVALID_SCHOOL_YEAR: 'year',
  BILLING_YEAR_PERIOD_MISMATCH: 'period',
  BILLING_CHARGE_SOURCE_MISMATCH: 'source',
  INVALID_AMOUNT: 'amount',
  BILLING_HISTORICAL_AMOUNT_INVALID: 'amount',
  BILLING_POSITIVE_AMOUNT_REQUIRED: 'amount',
  BILLING_ASSIGNMENT_STALE: 'stale',
  BILLING_ASSIGNMENT_INCOMPLETE: 'incomplete',
  BILLING_ASSIGNMENT_DUPLICATE: 'incomplete',
  BILLING_REVERSAL_REASON_REQUIRED: 'reason',
  BILLING_INTERNAL_ERROR: 'internal',
};

export function interfaceError(error, fallbackKey = 'common:errors.unexpected') {
  if (isMessage(error)) return error;
  const status = error && (error.status || error.statusCode);
  if (status === 401 || (error && error.code === 'UNAUTHORIZED')) return message('common:errors.unauthorized');
  if (status === 403 || (error && error.code === 'FORBIDDEN')) return message('common:errors.forbidden');
  const text = typeof error === 'string' ? error : error && error.message;
  if (text === 'FUTURE_ATTENDANCE_NOT_ALLOWED') return message('manage:futureAttendanceBlocked');
  if (billingErrors[text]) return message(`billing:yearScope.errors.${billingErrors[text]}`);
  // Resolve known application messages to descriptors; do not expose raw provider or server details.
  if (fallbackKey !== 'common:errors.unexpected' && ['Błąd zapisu', 'Save failed', 'Nie zapisano', 'Changes were not saved'].includes(text)) return message(fallbackKey);
  const translated = localizeSystemText(text, (key, params) => message(key, params));
  return isMessage(translated) ? translated : message(fallbackKey);
}
